<template>

<div class="ew-page">
  <navbar-dashboard name="Reporte de Sobrepesos"></navbar-dashboard>

  <div class="ew-page__body">
    <b-modal ref="editOverWeight" hide-footer title="Editar sobrepeso" modal-class="ew-modal">
          <form @submit.prevent="updateOverWeight" class="ew-form">
            <div class="ew-form__field">
              <label class="ew-label" for="ow-input">Sobrepeso (kg) *</label>
              <input id="ow-input" type="number" class="ew-input ew-input--block" placeholder="0.0" v-model="overweight" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="ow-cost-input">Costo *</label>
              <input id="ow-cost-input" type="number" class="ew-input ew-input--block" placeholder="0.00" v-model="cost_overweight" required>
            </div>
            <div class="ew-modal__actions">
              <button type="button" class="ew-btn-outline" @click="hideModalOverWeight">Cancelar</button>
              <button class="ew-btn-primary" type="submit">Guardar cambios</button>
            </div>
          </form>
    </b-modal>

    <b-tabs pills class="ew-tabs">
      <b-tab title="Envíos Web" active>

              <b-alert :show="dismissCountDown"
                    dismissible
                    variant="success"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                    class="ew-alert">
                {{message}}
              </b-alert>

              <div class="ew-toolbar ew-toolbar--end">
                <json-excel class="ew-btn-outline" :data="shipmentsExport" title="Exportar" name="overweight.xls">Exportar</json-excel>
              </div>

              <section class="ew-card">
                <div class="ew-filters">
                  <span class="ew-filters__label"><ph-icon name="funnel" />Seleccione periodo</span>
                  <form class="ew-filters__row" @submit.prevent>
                       <datepicker :bootstrap-styling="false"
                                  input-class="ew-input"
                                  :open-date="openDate"
                                  :format="customFormatter"
                                  :disabled-dates="{ from: new Date() }"
                                  v-model="date_ini"
                                  @closed="getAllShipmentsOverweightByDates">
                      </datepicker>
                      <datepicker :bootstrap-styling="false"
                                  input-class="ew-input"
                                  :open-date="openDate"
                                  :format="customFormatter"
                                  :disabled-dates="{ from: new Date() }"
                                  v-model="date_fin"
                                  @closed="getAllShipmentsOverweightByDates"
                              >
                      </datepicker>

                    <select class="ew-select" v-model.trim="selectedService" @change="filterShipmentsByCarriersServices(selectedService)">
                      <option selected>Servicios</option>
                      <option v-for="c in availableCarriers" :value="c" :key="c" >{{ carrierAndServiceCarrier(c) }}</option>
                    </select>

                    <select class="ew-select" v-model.trim="guideStatusFilter" @change="filterShipmentsByGuideStatus(guideStatusFilter)">
                      <option value="all">Estatus sobrepeso</option>
                      <option value="false">Pendiente</option>
                      <option value="true">Pagado</option>
                    </select>

                    <input type="text" class="ew-input ew-filters__keyword" placeholder="Palabra clave..." v-model="searchByKeywordCriteria" @keyup.enter="filterShipments(searchByKeywordCriteria)">
                  </form>

                  <div class="ew-filters__badges" v-if="filter.length > 0">
                    <span class="ew-badge" v-for="(c, i) in filter" :key="i">
                      {{printBadge(c)}}
                      <ph-icon name="x" @click.native="deletebadg(i)" />
                    </span>
                  </div>
                </div>

                <div class="table-responsive">
                  <div class="ew-loading" v-if="dataLoading">
                    <span class="ew-spinner"></span>
                    <p class="ew-loading-text">Cargando…</p>
                  </div>
                  <table class="ew-table" v-else-if="shipments.docs && shipments.docs.length > 0">
                    <thead>
                      <tr>
                         <th scope="col">Fecha guía</th>
                          <th scope="col">Usuario</th>
                        <th scope="col">Servicio</th>
                        <th scope="col">Sobrepeso</th>
                        <th scope="col">Costo sobrepeso</th>
                        <th scope="col">Estatus sobrepeso</th>
                        <th scope="col">N° de guía</th>
                        <th scope="col">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(s, i) in shipments.docs" v-bind:key="i" @dblclick="gotoShipmentDetails(s._id)" class="ew-table-row-clickable">
                         <td>{{ formatDate(s.created_at)}}</td>
                         <td>{{ s.customer_info.first_names}} {{ s.customer_info.last_names}} </br>
                            {{ s.customer_info.email}} </td>
                         <td>{{ s.selected_service.carrier }} -
                        {{ localCapitalize(s.selected_service.carrier_service_name)}}</td>
                        <td>{{ s.overweight }} kg</td>
                        <td>${{ s.cost_overweight }} </td>
                        <td>{{ s.overweight_paid? 'Pagado': 'Pendiente'  }}</td>
                        <td>{{numberGuide(s.number_guide)}}</td>
                        <td class="ew-table__amount" :class="{'is-pending': !s.status, 'is-paid': s.status}">
                          <small>{{ s.selected_service.currency }}</small> {{ s.selected_service.total_amount }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="ew-empty" v-else>
                    <ph-icon name="scales" />
                    <p class="ew-empty__title">Sin sobrepesos en este periodo</p>
                    <p class="ew-empty__text">Ajusta el rango de fechas o los filtros para ver más resultados.</p>
                  </div>
                </div>

                <div class="ew-pagination" v-if="shipments.docs && shipments.docs.length > 0">
                  <button class="ew-pagination__btn" @click="previousPage">Anterior</button>
                  <button class="ew-pagination__btn" @click="goToPage(p)" v-for="p in availablePages(shipments.page)" :key="p" :class="{'is-active': shipments.page === p }">{{ p }}</button>
                  <button class="ew-pagination__btn" @click="nextPage">Siguiente</button>
                </div>
              </section>

              <b-modal ref="myModalRef" id="modalcenter" centered title="Información preventiva" hide-footer modal-class="ew-modal">
                  <p class="ew-modal__text">Has seleccionado un envío que ya ha sido pagado; te invitamos a desmarcar las casillas correspondientes para poder continuar con tu operación.</p>
                  <div class="ew-modal__actions">
                    <button class="ew-btn-primary" @click="hideModal">Entendido</button>
                  </div>
              </b-modal>
      </b-tab>
      <!--<b-tab title="E-Commerce">
         <div class="row justify-content-between no-gutters">
                <div class="col-md-auto">

                </div>

                <div class="col-md-auto">
                  <router-link class="btn btn-primary mb-3 mr-0 px-4 py-2" to="/dashboard/shipment/new">Nuevo envío</router-link>
                </div>
              </div>

              <div class="ew-conten-table pt-4 pl-2 pr-2">
                <div class="mb-5 px-3">
                  <div class="mb-2">Filtrar busqueda por:</div>
                  <form @submit.prevent >
                    <div class="row">
                      <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Palabra clave..." v-model="key">
                      </div>
                    </div>
                  </form>
                </div>

                <div class="table-responsive ew-content-tabel">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Nombre</th>
                        <th scope="col">Destino</th>
                        <th scope="col">Servicio</th>
                        <th scope="col">N° de guía</th>
                        <th scope="col">Estatus guía</th>
                        <th scope="col">Total</th>
                        <th scope="col">Guía</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(s, i) in marketplaceList" v-bind:key="i" @click="gotoShipmentEcommerce(i)">
                        <td @click.stop>{{ s.destination_direction.full_name }}</td>
                        <td @click.stop>{{ s.destination_direction.address }}</td>
                        <td @click.stop>--</td>
                        <td @click.stop>--</td>
                        <td @click.stop>--</td>
                        <td @click.stop>--</td>
                        <td class="text-primary font-weight-bold">Generar Guia</td>
                        </tr>
                    </tbody>
                  </table>

                </div>
              </div>
              <b-modal ref="myModalRef" id="modalcenter" centered title="Información Preventiva" hide-footer>
                  <p class="my-4 text-justify" >A seleccionado un envio que ya ha sido pago, le invitamos a que desmarque las casillas correspondientes para poder continuar con su operación.</p>
                  <div class="row">
                      <div class="col-md">
                        <p class="text-right mt5">
                          <button class="btn btn-primary" @click="hideModal" >Cancelar</button>
                        </p>
                      </div>
                  </div>
              </b-modal>
      </b-tab>-->
    </b-tabs>
  </div>
</div>

</template>

<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '../commons/api'
import axios from 'axios'
import commons from '../commons'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import JsonExcel from "vue-json-excel";
import PhIcon from './icons/PhIcon'

export default {
  name: 'Dashboard',

  data () {
    return {
      key:'',
      dataLoading: true,
      statusGuide:[],
      message:"",
      dismissSecs: 5,
      dismissCountDown: 0,
      selected: [],
      currentPage: 1,
      searchByKeywordCriteria: '',
      guideStatusFilter: 'all',
      paquetes:'all',
      availableCarriers: [],
      selectedService: 'Servicios',
      filterShipmentsTimeoutID: '',
      filter:[],
      services:{
        dhl:["EXPRESS DOMESTIC 10:30", "EXPRESS DOMESTIC", "EXPRESS DOMESTIC 12:00"],
        redpack:["ECOEXPRESS", "EXPRESS"],
        ampm: ["ESTANDAR", "EXPRESS"]
      },
      date_ini: new Date(),
      openDate: new Date(),
      date_fin: new Date(),
      service: '',
      status: '',
      shipmentsExport: [],
      shipmentId: '',
      overweight: '',
      cost_overweight: '',
    }
  },

  created () {
    this.setNewShipmentEcommerce(null);
    this.getUser()
    Tawk_API.onLoad = function(){
        Tawk_API.showWidget()
        Tawk_API.minimize()
    };
    this.getAllShipmentsOverweightByDates()
    this.getMarketplace()
    this.getAllAvailableCarriers()

  },
  mounted(){
    try {
      Tawk_API.showWidget()
      Tawk_API.minimize()
    } catch (error) {

    }
  },
  beforeDestroy(){
    Tawk_API.hideWidget()
  },
  methods: {
    carrierAndServiceCarrier(serviceCarrier){
      if (this.services.dhl.includes(serviceCarrier)) {
        return `DHL - ${this.localCapitalize(serviceCarrier)}`
      } else if(this.services.redpack.includes(serviceCarrier)){
        return `Redpack - ${this.localCapitalize(serviceCarrier)}`
      } else if(this.services.ampm.includes(serviceCarrier)){
        return `AMPM - ${this.localCapitalize(serviceCarrier)}`
      }else{
        return `Fedex - ${this.localCapitalize(serviceCarrier)}`
      }
    },
    statusShipments(){
      let status = false
      this.selected.forEach(element => {
          if (element.status) {
            status = true
          }
      });
      return status
    },
    showModal () {
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    localCapitalize(string){
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    numberGuide(number, status, i){
      if (number !== null) {
        return number
      } else {
        return "Sin numero de guia"
      }
    },
    obtenerStatus(shipment)
    {
      if (shipment.number_guide == null) {
        return "Sin guía"
      }
      return shipment.tracking_status || "Sin verificar"
    },
    editOverWeight(id,overweight,cost_overweight)
    {
      this.shipmentId = id
      this.overweight = overweight
      this.cost_overweight = cost_overweight
      this.showModalOverWeight()
    },
    hideModalOverWeight () {
      this.$refs.editOverWeight.hide()
    },
    showModalOverWeight () {
      this.$refs.editOverWeight.show()
    },
    updateOverWeight(id,overweight)
    {

        axios
          .put(`${commons.apiURL}/api/v1/shipments/${this.shipmentId}`, {
            overweight: this.overweight,
            cost_overweight: this.cost_overweight
          })
          .then(response => {
              console.log(response.status)
              if(response.status == 200)
              {
                this.hideModalOverWeight()
              }
          })
          .catch(error => {
            console.error(error)
          })

    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    customFormatter(date) {
         return moment(String(date)).format('DD/MM/YYYY')
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    gotoShipmentDetails (id) {
      this.$router.push(`/shipments/${id}`)
    },
    gotoShipmentEcommerce(index){
      this.setNewShipmentEcommerce(this.marketplace[index]);
      this.$router.push(`/`)
    },
    previousPage () {
      axios.get(this.shipments.previous).then(response => {
        this.setShipments(response.data)
      })
    },
    nextPage () {
      axios.get(this.shipments.next).then(response => {
        this.setShipments(response.data)
      })
    },
    getAllShipmentsOverweightByDates () {
      this.getAllShipmentsOverweight(``);
    },
    goToPage (page) {
      this.getAllShipmentsOverweight(`&limit=10&page=${page}`)
    },
    getAllShipmentsOverweight(page)
    {
      var d1 = new Date(this.date_ini);
      var date_ini = [  d1.getFullYear(), d1.getMonth()+1,d1.getDate()]
          .map(n => n < 10 ? `0${n}` : `${n}`).join('-');
      var d2 = new Date(this.date_fin);
      var  date_fin = [  d2.getFullYear(), d2.getMonth()+1,d2.getDate()]
              .map(n => n < 10 ? `0${n}` : `${n}`).join('-');
      console.log(`${commons.apiURL}/api/v1/overweight/all?date_ini=${date_ini}&date_fin=${date_fin}T23:59:59&service=${this.service}&status=${this.status}&filter=${this.searchByKeywordCriteria}${page}`);
      axios
        .get(`${commons.apiURL}/api/v1/overweight/all?date_ini=${date_ini}&date_fin=${date_fin}T23:59:59&service=${this.service}&status=${this.status}&filter=${this.searchByKeywordCriteria}${page}`)
        .then(response => {
          this.setShipments(response.data)
          this.actualizaShipmentsExport()
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    actualizaShipmentsExport()
    {
      this.shipmentsExport = [];
      for(var i = 0; i < this.shipments.count;i++)
      {
        let s = this.shipments.docs[i];
        let rowExport =
        {
          fecha_guia: this.formatDate(s.created_at),
          usuario: s.customer_info.first_names + ' ' + s.customer_info.last_names,
          correo: s.customer_info.email,
          servicio: s.selected_service.carrier + ' - '+ s.selected_service.carrier_service_name,
          sobrepeso: s.overweight,
          costo_sobrepeso: s.cost_overweight,
          estatus_sobrepeso: s.overweight_paid ? 'Pagado' : 'Pendiente',
          guia: this.numberGuide(s.number_guide),
          total: s.selected_service.total_amount
        };
        this.shipmentsExport.push(rowExport);
      }
    },
    availablePages (page) {
      const result = []
      let initial = page > 1 ? page - 1 : 1
      let final = page < this.shipments.pages ? page + 1 : this.shipments.pages

      for (let i = initial; i <= final; i++) {
        result.push(i)
      }

      return result
    },
    deletebadg(i){
      this.filter.splice(i, 1);
    },
    filterShipments (criteria) {
      this.searchByKeywordCriteria = criteria
      this.getAllShipmentsOverweight(``)
    },
    filterShipmentsByGuideStatus (status) {
      this.status = status == 'all' ? '': status
      this.getAllShipmentsOverweight(``)
    },
    getAllAvailableCarriers () {
      api.shipment
        .getAllAvailableCarriers()
        .then(response => {
          this.availableCarriers = response.data

        })
        .catch(error => console.log(error))
    },
    filterShipmentsByCarriersServices (service) {

      this.service = service == 'Servicios' ? '': service
      this.getAllShipmentsOverweight(``)
    },
    downloadTracking (id) {
      const url = `https://www.enviosweb.com.mx/api/public/${id}.pdf`
      return url
      // axios.get(url).then(response => console.log('xxx'))
    },

    pmeayntsMany(){

      if (this.statusShipments()) {
        this.showModal()
      } else {
        this.setPaymentShipments(this.selected)
        this.$router.push('/payment/shipments/many')
      }
    },
    filterIsTrue(array_filter){
      let status = true;
      array_filter.forEach(element => {
        if (!element) {
          status = false;
        }
      });
      return status;
    },
    getFilterStatus(items, shipment){
      let list_filter = [];
      items.forEach(item => {
          if (shipment.ecommerce_type === undefined) {

            if (shipment.destination_direction.full_name.toLowerCase().includes(item.toLowerCase())) {
              list_filter.push(true)
            } else if(shipment.destination_direction.address.toLowerCase().includes(item.toLowerCase())){
              list_filter.push(true)
            }else if(shipment.selected_service.carrier_service_name.includes(item)){
              list_filter.push(true)
            }else if(item.toLowerCase() == "true" || item.toLowerCase() === "false") {
              let guide = (item.toLowerCase() == 'true')?true:false
              if (shipment.status === guide) {
                list_filter.push(true)
              }else{
                list_filter.push(false)
              }
            }else{
              list_filter.push(false)
            }
          } else {
            if (shipment.destination_direction.full_name.toLowerCase().includes(item.toLowerCase())) {
              list_filter.push(true)
            } else if(shipment.destination_direction.address.toLowerCase().includes(item.toLowerCase())){
              list_filter.push(true)
            }else {
              list_filter.push(false)
            }
          }
        });
        return list_filter;
    },
    printBadge(text){
      if (text == "true" || text == "false" ) {
        return (text == 'true')?'Pagado':'Guia sin pago'
      } else {
        return text
      }
    },
    ...mapMutations(['setShipments']),
    ...mapActions(['getUser', 'getMarketplace']),
    ...mapMutations(["setPaymentShipments"]),
    ...mapMutations(['setNewShipmentEcommerce'])
  },
  computed: {
   ...mapGetters(['shipments', 'user', "paymentShipments", 'marketplace']),
    shipmentWithGuide () {
      return []
    },
    shipmentWithoutGuide () {
      return []
    },
    selectAll: {
            get: function () {
                return this.shipments ? this.selected.length == this.shipments.length : false;
            },
            set: function (value) {
                var selected = [];
                if (value) {
                    this.shipments.forEach(function (shipment) {
                        selected.push(shipment);
                    });
                }
                this.selected = selected;
            }
    },
    shipmentsFilter: function(){
      try {
        return this.shipments.filter((shipment)=>{
          return this.filterIsTrue(this.getFilterStatus(this.filter, shipment))
        });
      } catch (error) {
        console.log("this.shipments",this.shipments)
      }

    },
    marketplaceList: function(){
      if (this.key.length > 2) {
        return this.marketplace.filter((item)=>{
          let word = this.key.toLowerCase().trim()
          if(item.destination_direction.full_name.toLowerCase().trim().includes(word)) {
            return true
          }else{
            return false
          }
        })
      } else {
        return this.marketplace
      }

    }
  },
  components: {
    'navbar-dashboard': Navbar,
     Datepicker,
     JsonExcel,
     PhIcon
  },

}

</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; }

.ew-tabs {
  /deep/ .nav-pills {
    border-bottom: 1px solid var(--app-border);
    margin-bottom: 1.5rem;
    .nav-link {
      padding: 0.6rem 0.25rem;
      margin-right: 1.75rem;
      border-radius: 0;
      font-family: var(--app-font);
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--app-muted);
      border-bottom: 2px solid transparent;
      &.active {
        color: var(--app-navy);
        background: transparent;
        border-bottom-color: var(--app-accent);
      }
    }
  }
}

.ew-alert { font-family: var(--app-font); border-radius: var(--app-radius-sm); margin-bottom: 1rem; }
.ew-toolbar { margin-bottom: 1rem; &.ew-toolbar--end { display: flex; justify-content: flex-end; } }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }

.ew-card { @include ew-card; margin-bottom: 2rem; }
.ew-filters { padding: 1.1rem 1.25rem; border-bottom: 1px solid var(--app-border); }
.ew-filters__label {
  display: flex; align-items: center; gap: 0.4rem; margin-bottom: 0.75rem;
  font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-muted);
  svg { width: 0.9rem; height: 0.9rem; }
}
.ew-filters__row { display: flex; flex-wrap: wrap; gap: 0.75rem; align-items: center; }
.ew-input { @include ew-input; }
.ew-select { @include ew-select; flex: 0 1 14rem; }
.ew-filters__keyword { flex: 1 1 14rem; }
.ew-filters__badges { display: flex; flex-wrap: wrap; gap: 0.5rem; margin-top: 0.9rem; }
.ew-badge { @include ew-badge; }

.ew-table { @include ew-table; }
.ew-loading { @include ew-loading; }
.ew-loading-text { @include ew-loading-text; }
.ew-spinner { @include ew-spinner; }
.ew-table-row-clickable { @include ew-table-row-clickable; }
.ew-table__amount { font-weight: 700; &.is-pending { color: var(--app-accent); } &.is-paid { color: #1a7f4f; } }

.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

.ew-pagination { display: flex; align-items: center; justify-content: center; gap: 0.4rem; padding: 1rem 1.25rem; border-top: 1px solid var(--app-border); }
.ew-pagination__btn { @include ew-pagination-btn; }

/* Modal editar sobrepeso (sin disparador en esta vista; ver nota entregada) */
.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; /* App.vue trae un .ew-form global con max-width:400px legado de los formularios de auth viejos; sin este reset se hereda igual (misma especificidad, propiedades distintas) */ }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input--block { width: 100%; }
.ew-modal__text { font-family: var(--app-font); color: var(--app-navy-secondary); text-align: left; }
.ew-modal__actions { display: flex; justify-content: flex-end; gap: 0.6rem; }
</style>

<style lang="scss">
@import "../assets/styles/app-tokens";
.ew-modal {
  .modal-content { border-radius: 0.85rem; border: none; }
  .modal-header { border-bottom: 1px solid $app-border; }
  .modal-title { font-family: $app-font-family; font-weight: 700; color: $app-navy; }
}
</style>



// WEBPACK FOOTER //
// src/components/OverweightReport.vue